<template>
    <div>
        <!-- Заголовок -->
  
        <q-toolbar color="primary" >
            <q-toolbar-title class='col-4'>
                 Вид постобработки
                <span slot="subtitle">
                <!-- Subtitle -->
                </span>
            </q-toolbar-title>
            <q-toolbar-title class='col-7 row'>
                Стоимость работ
            </q-toolbar-title>
             <q-toolbar-title class='col-2 row align-right' shrink>
                <q-btn v-if="notSaved" flat color="privary" icon="save" label="" @click="savePrice"/>
                <q-btn flat color="privary" icon="print" label=""/>
             </q-toolbar-title>
        </q-toolbar>
  
        <div 
             v-for="post in allPostTypes" 
             :key=post.id
             class="p-cost-line row no-wrap"
        >
            <div class='col-4'> {{post.name}} </div>
            <div class='col-7'>
                <post-price-edit 
                :postId=post.id />
            </div>
        </div>
    </div>    
</template>

<script>
/* eslint-disable */

import postPriceEdit from "./edit_postprice"


export default {
    name : "post_price",
    
    components : {
        postPriceEdit
    },

    created() {
       var list = this.$store.getters.getAllPostTypes;
       if (list.length == 0) { // возможно не загружены данные - загружаем
            this.$store.dispatch('getPostTypes');
       }
    },

    computed : {
        
        notSaved() {
            return this.$store.getters.savedPostStatus;
        },

        allPostTypes() {
            var list = [];
            if (this.$store.getters.getAllPostTypes != undefined) list = this.$store.getters.getAllPostTypes;
            return list;
        },

    }, 
    methods : {
        
        
        savePrice() {  //генерируем событие "сохранить прайс" - пусть контейнер прайсов его и обрабатывает
            eventBus.$emit('savePrice');
        },

        showNotify(nMessage, nType, detail='') {

            this.$admns.showNotify(nMessage, nType, detail);


        },
    }

}
</script>

<style lang="scss" scoped>
    .p-cost-line {
        background: #eee;
        padding:10px;
        border : 1px solid rgb(201, 201, 201);
        margin-top: -1px;
        &:hover {
            background: lightgreen;
        }
    }
</style>
